import fetch from '../../../../utils/fetch'

const getInitialState = () => {
  return {
    isLoading: false,
    userDownloads: null,
    error: null,
  }
}

const state = getInitialState();

const getters = {
  isLoading(state) {
    return state.isLoading
  },
  userDownloads(state) {
    return state.userDownloads
  },
  error(state) {
    return state.error
  },
}

const actions = {
  get({commit, rootGetters}, data) {
    commit(types.SET_PROJECT_DOWNLOADS_LOADING)
    return fetch( rootGetters['user/profile/iri'] + '/project_downloads' + data.urlParams)
      .then(response => response.json())
      .then((data) => {
        commit(types.SET_PROJECT_DOWNLOADS, data['hydra:member'])
        return data
      })
      .catch((error) => {
        commit(types.SET_PROJECT_DOWNLOADS_ERROR, error)
      })
  },
}

const types = {
  SET_PROJECT_DOWNLOADS_LOADING: 'SET_PROJECT_DOWNLOADS_LOADING',
  SET_PROJECT_DOWNLOADS: 'SET_PROJECT_DOWNLOADS',
  SET_PROJECT_DOWNLOADS_ERROR: 'SET_PROJECT_DOWNLOADS_ERROR',
  RESET: 'RESET',
}

const mutations = {
  [types.SET_PROJECT_DOWNLOADS_LOADING](state) {
    state.isLoading = true;
  },
  [types.SET_PROJECT_DOWNLOADS](state, projectDownloads) {
    state.userDownloads = projectDownloads
    state.isLoading = false
  },
  [types.SET_PROJECT_DOWNLOADS_ERROR](state, error) {
    state.error = error;
    state.isLoading = false;
  },
  [types.RESET](state) {
    Object.assign(state, getInitialState());
  },
}

export default {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
}
